import { LocationState } from 'src/modules/LocationState.ts';

export type LocationStateContextType = {
    locationState: LocationState;
    setLocationState: (state: LocationState) => void;
}

export const initLocationState: LocationState = {
    valveLabel: '',
    actuatorLabel: '',
    valvesPage: '1',
    selectedAccessories: [],
    actuatorsPage: '1',
    sent: false,
    combo: null,
    is6WayRequired: false,
    pipeConnectors: false,
    checkoutComment: '',
};

export const isLocationState = (arg: unknown): arg is LocationState => typeof arg === 'object' &&
    arg !== null && 'combo' in arg && arg.combo !== undefined;
